/* eslint-disable */
import mutations from "./mutations";

(function () {
  const ELEMENTS = [];
  const BOXSELECTOR = "[data-component=video-box]";
  const PREFIX = "video-";
  const SELECTOR = "[data-component=video-gallery]";

  function cachebustParameter() {
    return `&cachebust=${Math.floor(Math.random() * 1e8)}`;
  }

  function updateVideobox(box, iframe, srcBox) {
    const parent = box.closest(SELECTOR);
    const currentId = parent
      .getAttribute("aria-activedescendant")
      .split(PREFIX)
      .pop();
    const itemId = srcBox.id.split(PREFIX).pop();

    // update iframe
    iframe.setAttribute("hidden", "");
    iframe.src = "";
    iframe.dataset.src = srcBox.dataset.src;

    // update ids
    box.id = `${PREFIX}${itemId}`;
    srcBox.id = `${PREFIX}${currentId}`;

    // update filmstrip image and media source
    srcBox.dataset.src = srcBox.dataset.src.replace(itemId, currentId);
    const img = srcBox.querySelector("img");

    parent.setAttribute("aria-activedescendant", box.id);
    img.srcset = img.srcset.replace(itemId, currentId);
  }

  function play(e) {
    // in case button was clicked, not the image below it (both have listeners set)
    e.stopPropagation();
    const { target } = e;
    const container = target.closest(SELECTOR);
    const box = container.querySelector(BOXSELECTOR);
    const iframe = container.querySelector("iframe");

    if (!iframe) {
      return;
    }

    const srcBox = target.closest(BOXSELECTOR);

    if (srcBox !== box) {
      updateVideobox(box, iframe, srcBox);
    }

    window.requestAnimationFrame(() => {
      iframe.src = `${iframe.dataset.src}&autoplay=1${cachebustParameter()}`;
      iframe.removeAttribute("hidden");
      delete iframe.dataset.src;
    });
  }

  function process(container) {
    if (container.dataset.processed) {
      return;
    }

    const elements = container.querySelectorAll("picture, button");

    elements.forEach((element) => {
      ELEMENTS.push(element);
      element.addEventListener("click", play);
    });

    container.dataset.processed = true;
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(process);
  }

  function dispose() {
    while (ELEMENTS.length) {
      const element = ELEMENTS.pop();

      if (element) {
        element.removeEventListener("click", play);
      }
    }
  }

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      mutations.add(SELECTOR, process);
      init();
    },
    { once: true },
  );
  window.addEventListener("beforeunload", dispose);
})();
